function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useShowToast } from '@rd-web-markets/shared/dist/util/toast/useToast';
const quickUpdateApi = buildService('/companies/{id}/elster_quick_updates', {
  only: ['update']
});
const elstersApi = buildService('/companies/{id}/elsters', {
  only: ['delete']
});
const elsterQuickUpdatesService = {
  useUpdate: (companyId, setElster, setLoading, onSuccess) => {
    const quickUpdate = serviceMethods.useUpdate({
      callback: useCallback(async elster => {
        const updatedElster = await quickUpdateApi.update(companyId, elster.id, {
          elster: {
            version_number: elster.version_number,
            hidden: elster.hidden
          }
        });
        setElster(_objectSpread(_objectSpread({}, elster), {}, {
          version_number: updatedElster.version_number,
          hidden: updatedElster.hidden
        }));
        return updatedElster;
      }, [companyId, setElster]),
      setLoading,
      onSuccess: onSuccess ? () => onSuccess({
        pushToMasterPage: false
      }) : undefined
    });
    return [quickUpdate];
  },
  useDeleteElster: (companyId, onSuccess, setLoading) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const deleteElster = serviceMethods.useDelete({
      callback: useCallback(async elster => {
        if (!window.confirm(t('are_you_sure_you_want_to_delete_this_elster'))) return;
        await elstersApi.delete(companyId, elster.id);
        showToast({
          message: t('elster_deleted')
        });
        onSuccess === null || onSuccess === void 0 || onSuccess({
          pushToMasterPage: true
        });
      }, [companyId, onSuccess, showToast, t]),
      setLoading
    });
    return [deleteElster];
  }
};
elsterQuickUpdatesService.useCrud = function (companyId, setElster) {
  let setLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  let onSuccess = arguments.length > 3 ? arguments[3] : undefined;
  const [quickUpdate] = elsterQuickUpdatesService.useUpdate(companyId, setElster, setLoading, onSuccess);
  const [deleteElster] = elsterQuickUpdatesService.useDeleteElster(companyId, onSuccess, setLoading);
  return {
    quickUpdate,
    deleteElster
  };
};
export default elsterQuickUpdatesService;